import { createSelector } from 'reselect';
import * as R from 'ramda';

import { getModuleSelector } from 'src/utils/redux';

import { VehicleProtection } from '../vehicleProtections/types';
import { Extras } from '../extras/types';

import { ProductState } from './types';

const productsSelector = getModuleSelector<ProductState>('products');

export const productsAreLoadingSelector = createSelector<any, boolean>(
    productsSelector,
    R.prop<string, boolean>('loading'),
);

export const vehicleProtectionInsurancesSelector = createSelector<
    any,
    VehicleProtection[]
>(productsSelector, (productState: ProductState) => {
    return productState?.data?.insurances ?? [];
});

export const vehicleProtectionUpgradesSelector = createSelector<
    any,
    VehicleProtection
>(
    productsSelector,
    (vehicleProtection: ProductState) =>
        vehicleProtection?.data?.upgrade as VehicleProtection,
);

export const extrasSelector = createSelector<any, Extras>(
    productsSelector,
    (productState: ProductState) => {
        return productState?.data?.extras ?? {};
    },
);
